<template>
    <div class="logo">
        <img src="/images/data-providers-head.png" alt="Data Providers" />
        <a href="/" class="text">
            Data Providers
        </a>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
    .logo img {
        display: block;
        margin: 0 auto 20px;
    }

    .logo .text {
        font-family: 'Montserrat', sans-serif;
        font-size: 30px;
        text-transform: uppercase;
        background-color: transparent;
        font-weight: 600;
        height: auto;
        width: auto;
        padding: 0px;
        margin-right: 30px;
        line-height: 40px;
        text-align: center;
        display: block;
        width: 100%;
        color: #545454;
        margin: 15px 0px;
    }

    .logo .text:hover {
         text-decoration: none;
         text-shadow: 1px 1px 1px #ccc;
    }
</style>

